import React from 'react';
import './Terms.css'; // Optional: add styling if needed

const Terms = () => (
  <div className="legalWrapper">
    <h1>Terms & Conditions</h1>
    <p><strong>Last Updated:</strong> [Insert Date]</p>

    <p>Welcome to <strong>New ‘U’ Physical Therapy</strong>! By accessing our website at <a href="https://www.newuphysicaltherapy.com/" target="_blank" rel="noopener noreferrer">https://www.newuphysicaltherapy.com/</a>, you agree to the following Terms and Conditions:</p>

    <h2>Use of Website</h2>
    <p>
      You agree to use this website only for lawful purposes and in a way that does not infringe the rights of others. 
      You also agree to follow the website’s intended way of use.
    </p>

    <h2>Intellectual Property</h2>
    <p>
      All contents on this website are owned by or licensed to <strong>New ‘U’ Physical Therapy</strong>. 
      You may not copy, reproduce, or use our content without permission.
    </p>

    <h2>Accounts</h2>
    <p>
      If you create an account or receive your account details, you are responsible for maintaining the security of your login information. 
      Never share credentials, and no one at New ‘U’ Physical Therapy will ever ask for your password.
    </p>

    <h2>Limitation of Liability</h2>
    <p>
      We are not liable for any damages or losses resulting from your use of our website. 
      New ‘U’ Physical Therapy offers patients points as motivation to get the treatment, which can be saved and cashed in. 
      However, we do not advise patients/users to intentionally injure themselves to attempt to earn these points. 
      If discovered, we are not liable for any treatment and points may be denied.
    </p>

    <h2>Termination</h2>
    <p>
      We reserve the right to suspend or terminate your access if you violate these terms.
    </p>

    <h2>Changes</h2>
    <p>
      We may update these terms at any time. Your continued use of the site means you accept the updated terms. 
      With your consent, a notification will be sent letting you know that there has been an update.
    </p>

    <h2>Contact</h2>
    <p>
      If you have questions, feel free to contact us at <a href="mailto:newupt@yahoo.com">newupt@yahoo.com</a>.
    </p>
  </div>
);

export default Terms;
